import { AxiosConfig } from '../../../componentes/axiosConfig';

export class CriarUsuarioCliente {

    constructor() {
        this._axios = (new AxiosConfig()).instanciaAxios();

        this._formCadastroUsuario = 'form[name=form-usuarios-cliente-add]';
        this._idContainerUsuarios = 'container-usuarios-cliente';
        this._idBtnCriarUsuarios  = 'btn-criar-usuario-cliente';
        this._idFormCriarUsuarios = 'form-usuarios-cliente-add';
    }

    executar() {
        const containerUsuarios = $(`#${this._idContainerUsuarios}`);
        containerUsuarios.on('click', `#${this._idBtnCriarUsuarios}`, (evento) => {
            evento.preventDefault();
            this._criarVisao();
        });

        containerUsuarios.on('submit', this._formCadastroUsuario, (evento) => {
            evento.preventDefault();
            this._criarLogica();
        });
    }

    _criarVisao() {
        const containerUsuarios = document.getElementById(this._idContainerUsuarios);
        const btnCriarUsuario   = document.getElementById(this._idBtnCriarUsuarios);

        this._axios.get(btnCriarUsuario.href)
        .then((response) => {
            containerUsuarios.innerHTML = response.data;
            this._ativarSelect2();
        })
        .catch((error) => {
            console.log(error);
        });
    }

    _criarLogica() {
        const urlCriarUsuario   = document.querySelector(this._formCadastroUsuario).action;
        const dadosFormulario   = new FormData(document.getElementById(this._idFormCriarUsuarios));
        const containerUsuarios = document.getElementById(this._idContainerUsuarios);

        this._axios.post(urlCriarUsuario, dadosFormulario)
        .then((response) => {
            if (response) {
                containerUsuarios.innerHTML = response.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    _ativarSelect2() {
        $('.select2-js').select2();
    }
}
